import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';
import { GlobalService } from 'src/app/_services/global.service';



@Component({
  selector: 'app-setup-hp-edit',
  templateUrl: './setup-hp-edit.component.html',
  styleUrls: ['./setup-hp-edit.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class SetupHpEditComponent implements OnInit {

  action='';  
  ID:number;
  breadcrumbs: MenuItem[];
  roleslist:any[]=[];
  kpilist:any[]=[];
  homepage:any={
    id:'',
    name:'',
    descrizione:'',
    default_hp:0,
    widgets:[],
    kpi:[]
  };

  selectedKpi:any[]=[];
  selectedWidgets:any[]=[];
  selectedRoles:any[]=[];

  errors: {
    homepageNameError: boolean,
  };

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private messageService: MessageService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.initErrors();  
    this.action=this.route.snapshot.paramMap.get('action');
    this.ID=null;
    if (this.route.snapshot.paramMap.get('id')) {
        this.ID=parseInt(this.route.snapshot.paramMap.get('id'));
    }
    this.apiService.get('hp/kpilistall',{}).subscribe(data => {
      this.kpilist=data.Result;
      this.kpilist.forEach((k)=>{
        k.isprimary=false;
        k.alert=false;
        k.isSelected=false;
      });
    });
    if(this.ID){
      this.apiService.get('hp/listall',{}).subscribe(data => {
        data.Result.forEach((h)=>{
          if(h.id==this.ID){
            
            this.homepage=h;
            h.kpi.forEach((kp,ind) => {
              this.kpilist.forEach((k)=>{
                if(k.name==kp.name){
                  if(kp.isprimary){
                    k.isprimary=true;
                  }
               
                  k.alert=kp.alert;
                  k.isSelected=true;
                  this.selectedKpi.push(k);
                }
             
              });
             
            });
            console.log('aaaaa', this.selectedKpi);
  
            
            this.selectedRoles=h.roles;
          }
        });
        });
    }
  
  
    
    this.apiService.get('hp/roleslistall',{}).subscribe(data => {
      this.roleslist=data.Result;
    });
    
  

  }
  

  private validate() : boolean {
    let isValid : boolean = true;
    
    if (this.homepage.name=='') {
      this.errors.homepageNameError = true;
      isValid = false;
    }
    return isValid;
  }
  
  private initErrors() {
    this.errors = {} as any;
    this.errors.homepageNameError = false;
  }

  save(){
    this.initErrors();
    if (!this.validate()) return;
    if(this.ID){
      this.homepage.id=this.ID;
    }

    this.homepage.kpi=this.kpilist.filter(item => item.isSelected==true).map(item => {return item});;
    this.homepage.roles=this.selectedRoles;

    
    this.apiService.insertHp(this.homepage).subscribe(data => {
      this.addSingle('success', 'Successo', 'Homepage salvata con successo');
      this.router.navigateByUrl('/dashboard/setup-hp/list');
    });
  }
  
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

}
